import usePagination from '@mui/material/usePagination';
import { styled } from '@mui/material/styles';
import { Styles } from '../Styles';

const List = styled('ul')({
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
});

const PaginationComponent = (props) => {
    const { items } = usePagination({ ...props });

    return (
        <nav>
            <List>
                {items.map(({ page, type, selected, ...item }, index) => {
                    let children = null;

                    switch (type) {
                        case 'start-ellipsis':
                        case 'end-ellipsis':
                            children = '…';
                            break;
                        case 'page':
                            children = (
                                <button
                                    type="button"
                                    style={{
                                        ...Styles.paginationText
                                    }}
                                    {...item}
                                >
                                    {selected ? '[' + page + ']' : page}
                                </button>
                            );
                            break;
                        case 'previous':
                            children = (
                                <button
                                    type="button"
                                    style={{
                                        ...Styles.paginationText
                                    }}
                                    {...item}
                                >
                                    Previous Page
                                </button>
                            );
                            break;
                        case 'next':
                            children = (
                                <button
                                    type="button"
                                    style={{
                                        ...Styles.paginationText
                                    }}
                                    {...item}
                                >
                                    Next Page
                                </button>
                            );
                            break;
                        default:
                            children = (
                                <button
                                    type="button"
                                    style={{
                                        ...Styles.paginationText
                                    }}
                                    {...item}
                                >
                                    {type}
                                </button>
                            );
                    }

                    return (
                        <li key={index}>{children}</li>
                    );
                })}
            </List>
        </nav>
    );
};

export default PaginationComponent;